// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Create lock'"></sub-header>

    <!-- Product information -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product number:</span>
        <span class="value">{{\$ctrl.product.productNumber}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Product status:</span>
        <span class="value">{{\$ctrl.product.status | prettyEnum}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value">{{\$ctrl.product.balance | nxCurrency}}</span>
      </div>
    </div>

    <div ng-form name="\$ctrl.lockForm">
      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Lock type</td>
          <td>
            <select ng-model="\$ctrl.lock.type"
              ng-options="lock.type as lock.label for lock in \$ctrl.lockTypes"
              ng-required="true">
            </select>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Auto release</td>
          <td>
            <select
              required
              ng-model="\$ctrl.lock.autoRelease"
              boolean-options>
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.lock.autoRelease">
          <td></td>
          <td>Auto release on</td>
          <td>
            <date ng-model="\$ctrl.lock.autoReleaseOn"
              output-format="date"
              min="\$ctrl.minAutoReleaseDate()"
              ui-validate="'\$ctrl.isAutoReleaseDateValid(\$value)'"
              ng-required="true"></date>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Remarks</td>
          <td>
            <input
              required
              type="text"
              minlength="1"
              maxlength="128"
              ng-model="\$ctrl.lock.creationRemarks"/>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="buttons">
        <button
          class="btn btn-warning"
          ng-click="\$ctrl.redirectBack()"
          type="button">
          Cancel
        </button>
        <button
          class="btn btn-success"
          command-access="CreateProductLock"
          ng-click="\$ctrl.create()"
          ng-disabled="\$ctrl.lockForm.\$invalid">
          Create
        </button>
      </div>
    </div>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/common/create-lock/create-lock.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;